import MatManA from 'assets/images/MatMan/MatMan_Activity_Complete_A.png';
import MatManB from 'assets/images/MatMan/MatMan_Activity_Complete_B.png';
import MatManC from 'assets/images/MatMan/MatMan_Activity_Complete_C.png';
import MatManD from 'assets/images/MatMan/MatMan_Activity_Complete_D.png';
import MatManE from 'assets/images/MatMan/MatMan_Activity_Complete_E.png';
import MatManF from 'assets/images/MatMan/MatMan_Activity_Complete_F.png';
import MatManG from 'assets/images/MatMan/MatMan_Activity_Complete_G.png';
import MatManH from 'assets/images/MatMan/MatMan_Activity_Complete_H.png';
import MatManI from 'assets/images/MatMan/MatMan_Activity_Complete_I.png';
import MatManJ from 'assets/images/MatMan/MatMan_Activity_Complete_J.png';
import MatManK from 'assets/images/MatMan/MatMan_Activity_Complete_K.png';
import MatManL from 'assets/images/MatMan/MatMan_Activity_Complete_L.png';
import MatManM from 'assets/images/MatMan/MatMan_Activity_Complete_M.png';
import MatManN from 'assets/images/MatMan/MatMan_Activity_Complete_N.png';
import MatManO from 'assets/images/MatMan/MatMan_Activity_Complete_O.png';
import MatManP from 'assets/images/MatMan/MatMan_Activity_Complete_P.png';
import MatManQ from 'assets/images/MatMan/MatMan_Activity_Complete_Q.png';
import MatManR from 'assets/images/MatMan/MatMan_Activity_Complete_R.png';
import MatManS from 'assets/images/MatMan/MatMan_Activity_Complete_S.png';
import MatManT from 'assets/images/MatMan/MatMan_Activity_Complete_T.png';
import MatManU from 'assets/images/MatMan/MatMan_Activity_Complete_U.png';
import MatManV from 'assets/images/MatMan/MatMan_Activity_Complete_V.png';
import MatManW from 'assets/images/MatMan/MatMan_Activity_Complete_W.png';
import MatManX from 'assets/images/MatMan/MatMan_Activity_Complete_X.png';
import MatManY from 'assets/images/MatMan/MatMan_Activity_Complete_Y.png';
import MatManZ from 'assets/images/MatMan/MatMan_Activity_Complete_Z.png';

export const matManImage: { [character: string]: string } = {
  A: MatManA,
  B: MatManB,
  C: MatManC,
  D: MatManD,
  E: MatManE,
  F: MatManF,
  G: MatManG,
  H: MatManH,
  I: MatManI,
  J: MatManJ,
  K: MatManK,
  L: MatManL,
  M: MatManM,
  N: MatManN,
  O: MatManO,
  P: MatManP,
  Q: MatManQ,
  R: MatManR,
  S: MatManS,
  T: MatManT,
  U: MatManU,
  V: MatManV,
  W: MatManW,
  X: MatManX,
  Y: MatManY,
  Z: MatManZ,
};
